import { handleLogin } from '@/plugins/utils';
export default {
  props: {
    courseData: {
      required: true,
      type: Object
    },
    showLabel: {
      required: false,
      type: Boolean,
      default: false
    },
    labelContent: {
      required: false,
      type: String,
      default: 'course_type_name'
    },
    cols: {
      required: false,
      type: String,
      default: 'n + 3'
    },
    userInfo: {
      type: Object,
      default: null
    },
    authType: Number,
    zhsRole: {
      type: Number,
      default: 0
    }
  },
  methods: {
    async goDetail() {
      if (!this.userInfo) {
        handleLogin();
      } else {
        if (this.zhsRole === 3) {
          // 	0:未认证 1:管理者 2:老师 3:学生
          const hasPermission = await this.getHasPermission();

          if (!hasPermission && hasPermission != null) {
            ElMessage.error('暂无权限！');
            return;
          }

          if (hasPermission && hasPermission != null) {
            window.open(this.courseData.student_course_url);
          }
        } else {
          window.open(this.courseData.course_url);
        }
      }
    },

    async getHasPermission() {
      if (this.courseData.source_course_id == null) {
        ElMessage.error('暂无资源！');
        return null;
      } else {
        const data = await this.$http.getIsHasJoin(this.courseData && this.courseData.source_course_id);
        return Boolean(data);
      }
    }

  }
};